import { Inject } from "inversify-props";
import type { RegraDeInadimplenciaServiceAdapter } from "./adapter/RegraDeInadimplenciaServiceAdapter";
import { RegraDeInadimplencia } from "@/models";

export class SaveRegraDeInadimplenciaUseCase {
	@Inject('RegraDeInadimplenciaServiceAdapter')
			private regraDeInadimplenciaServiceAdapter!: RegraDeInadimplenciaServiceAdapter

			criarRegraDeInadimplencia = async (regraDeInadimplencia: RegraDeInadimplencia): Promise<RegraDeInadimplencia> =>
				await this.regraDeInadimplenciaServiceAdapter.criarRegraDeInadimplencia(regraDeInadimplencia)

			atualizarRegraDeInadimplencia = async (regraDeInadimplencia: RegraDeInadimplencia): Promise<RegraDeInadimplencia> =>
				await this.regraDeInadimplenciaServiceAdapter.atualizarRegraDeInadimplencia(regraDeInadimplencia)
}